exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clear-1[data-v-a3ca8592] {\n  height: 1rem;\n}\n.clear-2[data-v-a3ca8592] {\n  height: 2rem;\n}\np[data-v-a3ca8592] {\n  line-height: 1.2;\n  margin: 0 0 10px;\n}", ""]);

// exports
